import type { LocalEvent } from "./model";

/**
 * Returns whether a local event belongs to the signed-in person, not to a person they recorded it
 * for on behalf (T-170). Only own events count for the own clock state, timeline and conflicts.
 *
 * @param event - The local event.
 * @returns `true` for an own event.
 */
export function isOwnEvent(event: LocalEvent): boolean {
  const own = event.employeeId === undefined || event.employeeId === null;
  return own;
}
